var _g, _g2, _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigCorrectIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1472,
    y: 15.1037,
    width: 69.6922,
    height: 69.6922,
    rx: 34.8461,
    stroke: "#16A763",
    strokeWidth: 7.45061
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.42941,
    y: 4.39132,
    width: 91.1208,
    height: 91.1208,
    rx: 45.5604,
    stroke: "#16A763",
    strokeWidth: 7.45061
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.999 39.9497V49.9497M49.999 59.9497H50.024M74.999 49.9497C74.999 63.7568 63.8061 74.9497 49.999 74.9497C36.1919 74.9497 24.999 63.7568 24.999 49.9497C24.999 36.1426 36.1919 24.9497 49.999 24.9497C63.8061 24.9497 74.999 36.1426 74.999 49.9497Z",
    stroke: "#16A763",
    strokeWidth: 7.45061,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.0005,
    cy: 49.9487,
    r: 14.8228,
    fill: "#DDEDE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0679 42.761C59.3907 42.4294 59.8299 42.2364 60.2924 42.2229C60.651 42.2126 61.0043 42.3109 61.3061 42.5047C61.6079 42.6985 61.8442 42.9791 61.984 43.3094C62.1239 43.6397 62.1608 44.0038 62.0898 44.3554C62.0189 44.707 61.8435 45.0293 61.5865 45.2796L49.7123 57.1538C49.3783 57.4877 48.9253 57.6756 48.453 57.6756C47.9807 57.6756 47.5277 57.4877 47.1937 57.1538L41.2566 51.2167C41.0856 51.0526 40.9492 50.8556 40.8551 50.6381C40.7611 50.4205 40.7115 50.1862 40.7091 49.9493C40.7067 49.7123 40.7516 49.4775 40.8411 49.2581C40.9307 49.0387 41.0631 48.8401 41.2307 48.6725C41.3983 48.505 41.5976 48.3725 41.817 48.2829C42.0363 48.1934 42.2714 48.1483 42.5084 48.1507C42.7454 48.1531 42.9795 48.2028 43.197 48.2968C43.4145 48.3909 43.6111 48.5271 43.7752 48.6981L48.453 53.3758L59.0679 42.761Z",
    fill: "#16A763"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigCorrectIcon);
export default __webpack_public_path__ + "static/media/BigCorrectIcon.b454444706ff7581fc6080f808953154.svg";
export { ForwardRef as ReactComponent };